// Ported from design_handoff/source/chrome.jsx — kept identical SVG paths.

type IconName = 'search' | 'filter' | 'sort' | 'close' | 'grid' | 'rows' | 'arrow';

export function Icon({ name, size = 14 }: { name: IconName; size?: number }) {
  const s = size;
  switch (name) {
    case 'search':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        >
          <circle cx="7" cy="7" r="4.5" />
          <path d="M10.5 10.5 14 14" strokeLinecap="round" />
        </svg>
      );
    case 'filter':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        >
          <path d="M2 4h12M4 8h8M6 12h4" strokeLinecap="round" />
        </svg>
      );
    case 'sort':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        >
          <path
            d="M4 3v10M4 13l-2-2M4 13l2-2M12 13V3M12 3l-2 2M12 3l2 2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M4 4l8 8M12 4l-8 8" strokeLinecap="round" />
        </svg>
      );
    case 'grid':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.3"
        >
          <rect x="2.5" y="2.5" width="4" height="4" />
          <rect x="9.5" y="2.5" width="4" height="4" />
          <rect x="2.5" y="9.5" width="4" height="4" />
          <rect x="9.5" y="9.5" width="4" height="4" />
        </svg>
      );
    case 'rows':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.3"
        >
          <rect x="2.5" y="2.5" width="11" height="3" />
          <rect x="2.5" y="7" width="11" height="3" />
          <rect x="2.5" y="11.5" width="11" height="2" />
        </svg>
      );
    case 'arrow':
      return (
        <svg
          width={s}
          height={s}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M4 8h8M9 5l3 3-3 3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
  }
}
